module.exports = __webpack_public_path__ + "static/media/logo.f21e19da.svg";